var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.903 3.488a.867.867 0 0 1 1.194 0l4.43 4.266c.329.317.329.831 0 1.149a.867.867 0 0 1-1.194 0L13.5 5.212l-3.833 3.69a.867.867 0 0 1-1.193 0 .791.791 0 0 1 0-1.148l4.43-4.266Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 3.25c.466 0 .844.364.844.813v11.375c0 .448-.378.812-.844.812-.466 0-.844-.364-.844-.813V4.063c0-.45.378-.813.844-.813Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.219 14.625c.466 0 .843.364.843.813v5.687h16.875v-5.688c0-.448.378-.812.844-.812.466 0 .844.364.844.813v5.687c0 .431-.178.844-.494 1.149a1.72 1.72 0 0 1-1.194.476H5.063a1.72 1.72 0 0 1-1.193-.476 1.595 1.595 0 0 1-.494-1.149v-5.688c0-.448.378-.812.844-.812Z",
    fill: "currentColor"
  })));
};
export default SvgShare;